// Copyright © 2021 Move Closer
// Domain enum for gradient colors
export var GradientDomain;
(function (GradientDomain) {
    GradientDomain["Defence24PL"] = "defence24.pl";
    GradientDomain["Energetyka24COM"] = "energetyka24.com";
    GradientDomain["CyberDefence24PL"] = "cyberdefence24.pl";
    GradientDomain["Space24PL"] = "space24.pl";
    GradientDomain["Defence24COM"] = "defence24.com";
    GradientDomain["InfoSecurity24PL"] = "infosecurity24.pl";
    GradientDomain["Defence24MSPO"] = "mspo.defence24.pl";
    GradientDomain["Defence24TV"] = "defence24.tv";
})(GradientDomain || (GradientDomain = {}));
/**
 * Tile's sizing variant.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export var TileVersion;
(function (TileVersion) {
    TileVersion["S"] = "S";
    TileVersion["L"] = "L";
    TileVersion["XL"] = "XL";
    TileVersion["FourColumns"] = "4-columns";
    TileVersion["FiveColumns"] = "5-columns";
})(TileVersion || (TileVersion = {}));
export var Breakpoint;
(function (Breakpoint) {
    Breakpoint["XS"] = "xs";
    Breakpoint["SM"] = "sm";
    Breakpoint["MD"] = "md";
    Breakpoint["LG"] = "lg";
    Breakpoint["XL"] = "xl";
    Breakpoint["XXL"] = "xxl";
})(Breakpoint || (Breakpoint = {}));
